import axios from 'axios'
import store from '@/store'
import router from '@/router'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE
})

http.interceptors.request.use(
  config => {
    const source = axios.CancelToken.source()
    config.cancelToken = source.token
    store.commit('http/ADD_CANCEL_TOKEN', source)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 401) {
      store.commit('auth/REMOVE_SESSION')
      return router.push({name: 'SessionExpired'})
    }
    return Promise.reject(error)
  }
)

export default http
